import { render, staticRenderFns } from "./Nuevo.vue?vue&type=template&id=62027f46&scoped=true"
import script from "./Nuevo.vue?vue&type=script&lang=js"
export * from "./Nuevo.vue?vue&type=script&lang=js"
import style0 from "./Nuevo.vue?vue&type=style&index=0&id=62027f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62027f46",
  null
  
)

export default component.exports